import { SearchTriggerType } from 'pf-frontend-common/src/module/stats/types';

import { objectFilterFalsy } from 'common/helper/object/filter/falsy';
import { AgentSerpStoreStateResultsInterface } from 'common/module/agent-serp/store/state-results.interface';
import { AgentSerpStoreOptionsInterface } from 'common/module/agent-serp/store-options.interface';
import { DataStore } from 'common/module/data/store';
import { InputSelectOptionInterface } from 'common/module/input/select/option.interface';
import { AgentSerpStoreServiceInterface } from 'common/service/agent-serp-store/service.interface';

import { AgentSerpStoreStateInterface } from './store/state.interface';
import { AgentSerpStoreStateParamsInterface } from './store/state-params.interface';

export class AgentSerpStore extends DataStore implements AgentSerpStoreServiceInterface {
  /**
   * @inheritDoc
   */
  protected state: AgentSerpStoreStateInterface = {
    trigger: 'initial',
    params: {
      'page[number]': 1,
      'page[limit]': 20,
      sort: '',
    },
    results: {
      count: 0,
      list: [],
    },
    inputs: {
      sort: [],
      category: [],
      nationality: [],
      language: [],
    },
  };

  /**
   * @inheritDoc
   */
  public initialize(options: AgentSerpStoreOptionsInterface): void {
    if (options.form) {
      this.state.params['filter[name]'] = options.form.text || '';
      this.state.params['filter[language_ids]'] = options.form.languageIds || [];
      this.state.params['filter[nationality]'] = options.form.nationality || '';
      this.state.params['filter[category_id]'] = options.form.categoryId || '';
      this.state.params['filter[id]'] = options.form.id || '';
      this.state.params['filter[location_id]'] = options.form.locationId || '';

      this.state.params.sort = options.form.orderBy || options.form.sort[0].id;

      this.state.inputs.sort = options.form.sort.map((option) => ({
        value: option.id,
        text: option.text,
      }));

      this.state.inputs.category = options.form.categories.map((option) => ({
        value: option.id,
        text: option.text,
      }));

      this.state.inputs.nationality = options.form.nationalities.map((option) => ({
        value: option.id,
        text: option.text,
      }));

      this.state.inputs.language = options.form.languages.map((option) => ({
        value: option.id,
        text: option.text,
      }));
    }

    if (options.searchOutput) {
      this.state.params['page[number]'] = options.searchOutput.pagination.page;
      this.state.results.count = options.searchOutput.pagination.totalCount;
      this.state.results.list = options.searchOutput.agents.map((agentModel) => agentModel.id);
    }
  }

  /**
   * @inheritDoc
   */
  public getState(): AgentSerpStoreStateInterface {
    return this.state;
  }

  /**
   * @inheritDoc
   */
  public getAutocompleteSelection(): InputSelectOptionInterface | null {
    const params = this.state.params;

    const value = params['filter[id]'] || params['filter[location_id]'];
    const text = params['filter[name]'];

    if (value && text) {
      return {
        value,
        text,
      };
    }

    return null;
  }

  /**
   * @inheritDoc
   */
  public setParams(params: AgentSerpStoreStateParamsInterface): void {
    this.state = {
      ...this.getState(),
      params,
    };
  }

  /**
   * @inheritDoc
   */
  public updateParams(
    params: AgentSerpStoreStateParamsInterface,
    trigger?: SearchTriggerType,
    silent?: boolean // TODO-FE[later] stinks of shortcut, please remove and use setParams() instead
  ): Promise<void> {
    const state: AgentSerpStoreStateInterface = {
      ...this.getState(),
      trigger: trigger || 'update',
      params: objectFilterFalsy({
        ...this.getState().params,
        ...params,
      }),
    };

    if (silent) {
      this.state = state;
      return Promise.resolve(); // TODO-FE[later] Why using promise ?
    }

    this.setState(state, this.updateParams);

    return Promise.resolve(); // TODO-FE[later] Why using promise ?
  }

  /**
   * @inheritDoc
   */
  public updateResults(results: AgentSerpStoreStateResultsInterface): Promise<void> {
    const state = this.getState();

    state.results.count = results.count;
    state.results.list = results.list;

    this.setState(state, this.updateResults);

    return Promise.resolve(); // TODO-FE[later] Why using promise ?
  }
}
